module.exports = __webpack_public_path__ + "static/media/AB_K18_6.14a3f11a.jpg";